import styled from 'styled-components'
import { Dropdown } from 'semantic-ui-react'
import Arrow from '../../../../assets/images/dropdown2.svg'

export const DropdownContainer = styled(Dropdown)`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  outline: 0;
  text-align: left;
  color: ${({ theme }) => theme.text1};
  width: 100%;

  .divider.text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;

    :after {
      content: ' ';
      font-size: 1.2rem;
      font-weight: bold;
      width: 15px;
      height: 15px;
      display: block;
      background-image: url('${Arrow}');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    }
  }
  img {
    border-radius: 100%;
    width: 24px;
    height: 24px;
    margin-right: 0.5rem;
  }

  .menu {
    cursor: auto;
    position: absolute;
    display: none;
    outline: 0;
    top: 100%;
    min-width: -webkit-max-content;
    min-width: -moz-max-content;
    min-width: max-content;
    margin-top: 0.5rem;
    padding: 0 0;
    font-size: 1em;
    text-shadow: none;
    text-align: left;
    -webkit-box-shadow: 0 2px 3px 0 rgb(34 36 38 / 15%);
    box-shadow: 0 2px 3px 0 rgb(34 36 38 / 15%);
    border: 1px solid rgba(34, 36, 38, 0.15);
    -webkit-transition: opacity 0.1s ease;
    transition: opacity 0.1s ease;
    z-index: 11;
    will-change: transform, opacity;
    background-color: ${({ theme }) => theme.bg7};
    width: 120px;

    .item {
      color: #fff;
      position: relative;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: none;
      height: auto;
      text-align: left;
      border-top: none;
      line-height: 1em;
      padding: 0.5rem;
      font-size: 1rem;
      text-transform: none;
      font-weight: 400;
      -webkit-box-shadow: none;
      box-shadow: none;
      -webkit-touch-callout: none;
    }
  }

  .visible.transition {
    display: block !important;
    visibility: visible !important;
  }
`